/**
 * Format a date as "X ago" relative to current time
 */
export function formatTimeAgo(date: Date): string {
  const seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);

  if (seconds < 60) return 'Just now';
  if (seconds < 120) return '1 minute ago';
  if (seconds < 3600) return `${Math.floor(seconds / 60)} minutes ago`;
  if (seconds < 7200) return '1 hour ago';
  return `${Math.floor(seconds / 3600)} hours ago`;
}

/**
 * Get color based on data staleness
 */
export function getDataFreshnessColor(date: Date): 'success' | 'warning' | 'error' | 'default' {
  const minutes = Math.floor((new Date().getTime() - date.getTime()) / 60000);

  if (minutes < 5) return 'success';   // Fresh - green
  if (minutes < 15) return 'warning';  // Getting stale - orange
  return 'error';                      // Very stale - red
}